export const environment = {
    production: true,
    apiUrl: 'https://qas-api.portalito.mx/api'
};
